module.exports = __webpack_public_path__ + "img/nav-design-withdiamonds.0379f47.webp";